import React from "react";

const Announcements = () => {
  return (
    <div className="announcement-layout">
      <h3>From the developer</h3>
      <br />
      <div className="annunc">
        <p>
          Expect an update v1.1 which will focus on fixing bugs and issues with
          the app
        </p>
      </div>
    </div>
  );
};

export default Announcements;
